import template from './documentThumbnail.html';
import controller from './documentThumbnail.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  transclude: true,
  bindings: {
    document: '<',
    imageClass: '@',
    maxsize: '@',
  },
};

export default component;
